import { axiosEjFetch as axiosFetch } from "./axiosEjHelpers";

export type NewsletterSubscriptionResponseType = {
  createdOnUtc: string;
  email: string | null;
  phone: string | null;
  reservationId: string;
};

export type CreateNewsletterSubscriptionType = {
  photoSessionId: string;
  email: string | null;
  phoneNumber: string | null;
};

export async function postNewsletterSubscription(
  body: CreateNewsletterSubscriptionType
) {
  return axiosFetch.post("/api/newsletterSubscription", body);
}

export async function deleteNewsletterSubscription(id: string) {
  return axiosFetch.del(`/api/newsletterSubscription/${id}`);
}

export async function getNewsletterSubscriptionsList(): Promise<
  NewsletterSubscriptionResponseType[]
> {
  return axiosFetch.safeGet<any, any, NewsletterSubscriptionResponseType[]>(
    "/api/newsletterSubscription"
  );
}
